import { render } from "./oauth2.vue?vue&type=template&id=0ba8ccc0"
import script from "./oauth2.vue?vue&type=script&lang=js"
export * from "./oauth2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__